(function () {
  'use strict';
  const day = 86400000;

  /** Today's calendar date in Toronto, where orders are prepared, as a UTC timestamp. */
  function torontoToday() {
    const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date());
    const part = (type) => Number(parts.find((item) => item.type === type).value);
    return Date.UTC(part('year'), part('month') - 1, part('day'));
  }

  /** Counts business days after a date, skipping weekends and closed dates; zero means the next open day. */
  function addBusinessDays(start, count, closed) {
    const open = (date) => ![0, 6].includes(new Date(date).getUTCDay()) && !closed.has(date);
    let date = start;
    let remaining = count;
    while (remaining > 0 || !open(date)) {
      date += day;
      if (open(date)) remaining -= 1;
    }
    return date;
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-delivery-estimate]').forEach((root) => {
      if (root.dataset.deliveryInitialized) return;
      root.dataset.deliveryInitialized = 'true';
      const [preparationMin, preparationMax] = root.dataset.preparation.split(',').map(Number);
      const [transitMin, transitMax] = root.dataset.transit.split(',').map(Number);
      const closed = new Set((root.dataset.closed.match(/\d{4}-\d{2}-\d{2}/g) || []).map((date) => Date.parse(date + 'T00:00:00Z')));
      const format = new Intl.DateTimeFormat(root.dataset.locale || 'en', { month: 'short', day: 'numeric', timeZone: 'UTC' });
      const range = (start, end) => {
        if (start === end) return format.format(start);
        const sameYear = new Date(start).getUTCFullYear() === new Date(end).getUTCFullYear();
        return sameYear && typeof format.formatRange === 'function' ? format.formatRange(start, end) : format.format(start) + ' – ' + format.format(end);
      };
      const today = torontoToday();
      const shipsFrom = addBusinessDays(today, preparationMin, closed);
      const shipsBy = addBusinessDays(today, preparationMax, closed);
      root.querySelector('[data-delivery-ships]').textContent = range(shipsFrom, shipsBy);
      root.querySelector('[data-delivery-arrives]').textContent = range(addBusinessDays(shipsFrom, transitMin, closed), addBusinessDays(shipsBy, transitMax, closed));
      const purchase = root.closest('[data-bundle-purchase]');
      const repeat = root.querySelector('[data-delivery-repeat]');
      if (!purchase || !repeat) return;
      const updateRepeat = () => {
        const subscribed = purchase.querySelector('[name="bundle_mode"]:checked')?.value === 'replenishment';
        const plan = purchase.querySelector('[name="bundle_frequency"]')?.selectedOptions?.[0];
        repeat.hidden = !subscribed || !plan;
        if (!repeat.hidden) repeat.querySelector('[data-delivery-repeat-date]').textContent = plan.textContent;
      };
      purchase.addEventListener('change', (event) => {
        if (event.target.matches('[data-bundle-set], [name="bundle_mode"], [name="bundle_frequency"]')) updateRepeat();
      });
      updateRepeat();
    });
  }

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
